import React from 'react';

import PendingTable from './PendingTable';
import ResolveSubmissionModal from './ResolveSubmissionModal';
import styles from './NeovarsityManagementPendingPage.module.scss';

const NeovarsityManagementPendingPage = () => {
  return (
    <div className={styles.root}>
      <PendingTable />
      <ResolveSubmissionModal />
    </div>
  );
};

export default NeovarsityManagementPendingPage;
